module.exports = __webpack_public_path__ + "img/运动康养_2@2x.17c78d09.png";